"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerInvoiceContact = void 0;
const typeorm_1 = require("typeorm/browser");
const customer_contact_1 = require("./customer-contact");
let CustomerInvoiceContact = class CustomerInvoiceContact extends customer_contact_1.CustomerContact {
};
CustomerInvoiceContact = __decorate([
    (0, typeorm_1.ViewEntity)({
        expression: `
    SELECT c.*
    FROM public.contact c
    JOIN public.account a ON (c.accountid = a.id)
    WHERE
        c.use_as__c = 'Invoice' OR c.use_as__c = 'Default'
    ORDER BY c.use_as__c DESC
    LIMIT 1
`,
    })
], CustomerInvoiceContact);
exports.CustomerInvoiceContact = CustomerInvoiceContact;
//# sourceMappingURL=customer-invoice-contact.js.map